<template>
  <div class="saved-items">
    <div class="top-section">
      <h2>כאן אנחנו שומרים את מה שאהבת</h2>
      <div class="columns is-centered saved-items-filter">
        <div>
          <a :class="cls(0)" href="#" @click.prevent="setSelected(0)">הכל</a>
        </div>
        <div>
          <a :class="cls(1)" href="#" @click.prevent="setSelected(1)"
            >שיעורים</a
          >
        </div>
        <div>
          <a :class="cls(2)" href="#" @click.prevent="setSelected(2)">סדרות</a>
        </div>
        <div>
          <a :class="cls(3)" href="#" @click.prevent="setSelected(3)"
            >תוכניות אימונים</a
          >
        </div>
      </div>
    </div>

    <div class="playlist-controls container">
      <a class="playlist-controls" @click.prevent="showModal = !showModal">
        <i :class="createPlaylistIcon"></i>
        {{ createPlaylistLabel }}
      </a>
      <select-playlist
        v-if="$store.state.user.playlists.length > 0"
      ></select-playlist>
    </div>

    <div style="margin-bottom: 1rem">
      <playlist-videos
        :videos="itemsToShow"
        v-on:add-to-playlist="addToPlaylist"
      ></playlist-videos>
    </div>

    <transition name="fade">
      <div :class="modalCls" v-if="showModal">
        <div class="modal-background" @click="showModal = false"></div>
        <div class="modal-wrapper">
          <div class="modal-content">
            <div class="modal-top">
              <a href="#" @click.prevent="showModal = false">
                <i class="mdi mdi-close"></i>
              </a>
            </div>
            <div class="save-playlist" v-if="!saved">
              <input type="text" v-model="title" placeholder="שם לפלייליסט" />
              <a href="#" @click.prevent="savePlaylist">
                <i class="mdi mdi-check-circle-outline" v-if="!saving"></i>
                <div v-else><spinner></spinner></div>
              </a>
            </div>
            <div class="save-playlist" v-else>
              <h3>הפלייליסט נשמר</h3>
              <a href="#" @click.prevent="savePlaylist">
                <i class="mdi mdi-check-circle"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import PlaylistVideos from "@/components/playlists/playlistVideos.vue";
import GroupVideos from "@/components/series/GroupVideos.vue";
import CollectionList from "@/components/series/CollectionList.vue";
import Teachers from "@/components/teachers/Teachers.vue";
import SelectPlaylist from "@/components/playlists/selectPlaylist.vue";
import Spinner from "@/components/spinner.vue";

export default {
  components: {
    PlaylistVideos,
    GroupVideos,
    CollectionList,
    Teachers,
    SelectPlaylist,
    Spinner,
  },
  data() {
    return {
      selected: 0,
      showModal: false,
      title: "",
      saved: false,
      saving: false,
    };
  },
  methods: {
    cls(selected) {
      if (selected == this.selected) {
        return "saved-filter-item active";
      }
      return "saved-filter-item";
    },
    setSelected(selected) {
      this.selected = selected;
    },
    addToPlaylist(event) {
      this.$store.dispatch("addToPlaylist", {
        allItems: this.allItems,
        toAdd: event,
      });
    },
    savePlaylist() {
      this.saving = true;
      let payload = {
        title: this.title,
        videos: this.currentPlaylist.videos.join(","),
        series: this.currentPlaylist.series.join(","),
        collections: this.currentPlaylist.collections.join(","),
      };
      if (this.currentPlaylist.id !== "0") {
        payload.playlistId = this.currentPlaylist.id;
      }
      this.$store.dispatch("savePlaylist", payload).then(data => {
        if (data.success === 1) {
          //success
          this.saved = true;
          this.saving = false;
          setTimeout(() => {
            this.showModal = false;
          }, 1000);
          window.clearTimeout;
          setTimeout(() => {
            this.$store.dispatch("selectPlaylist", "0");
            this.$router.push("/savedItems");
          }, 1300);
          window.clearTimeout;
        }
      });
    },
  },
  computed: {
    videoList() {
      return this.$store.state.videos;
    },
    myvideos() {
      const vidArray = this.$store.state.user.myVideos;

      const arr = this.videoList.filter(v => {
        if (vidArray.includes(`${v.id}`)) {
          return true;
        }
        return false;
      });
      return arr;
    },
    videoCollections() {
      const arr = this.$store.state.series.filter(s => {
        if (
          this.$store.state.user.mySeries.indexOf(`${s.id}`) > -1 &&
          s.parent !== `10`
        ) {
          return true;
        }
        return false;
      });
      return arr;
    },
    seriesObjects() {
      const arr = this.$store.state.series.filter(s => {
        if (
          this.$store.state.user.mySeries.indexOf(`${s.id}`) > -1 &&
          s.parent === `10`
        ) {
          return true;
        }
        return false;
      });
      return arr;
    },
    allItems() {
      let output = [];
      let series = [];
      [...this.videoCollections, ...this.seriesObjects].forEach(s => {
        const videos = s.videoItems.split("||");
        if (this.videoList.length > 0) {
          videos.every(v => {
            const full = this.videoList.filter(
              vid => vid.id === parseInt(v, 10)
            )[0];
            series.push({
              id: s.id,
              pagetitle: s.pagetitle,
              image: full.ch,
              current: full.current,
              teacher: full.videoTeacher,
              description: s.description,
              level: full.videoLvl,
              videoRating: full.videoRating,
              videoDuration: full.videoDuration,
              publishedon: full.publishedon,
              type: "series",
              parent: s.parent,
            });
            return false;
          });
        }
      });
      output = [...this.myvideos, ...series];
      return output;
    },
    itemsToShow() {
      if (this.selected === 1) {
        return this.allItems.filter(item => item.type !== "series");
      }
      if (this.selected === 2) {
        return this.allItems.filter(
          item => item.type === "series" && item.parent !== "10"
        );
      }
      if (this.selected === 3) {
        return this.allItems.filter(
          item => item.type === "series" && item.parent === "10"
        );
      }
      if (this.selected === 4) {
        return [];
      }
      return this.allItems;
    },
    createPlaylistLabel() {
      return "שמירת פלייליסט";
    },
    createPlaylistIcon() {
      return "mdi mdi-check-circle-outline";
    },
    modalCls() {
      if (this.showModal) {
        return "modal is-active";
      }
      return "modal";
    },
    currentPlaylist() {
      return this.$store.state.user.currentPlaylist;
    },
  },
  watch: {
    currentPlaylist() {
      this.title = this.currentPlaylist.title;
    },
  },
  mounted() {
    this.title = this.$store.state.user.currentPlaylist.title;
  },
};
</script>

<style lang="scss">
.saved-items {
  .modal-content {
    background-color: #ffffff;
    border-radius: 1rem;
    padding: 0 2rem 2rem 2rem;
    .modal-top {
      display: flex;
      justify-content: flex-end;
      a {
        color: #000000;
        font-size: 1.5rem;
      }
    }
    .save-playlist {
      display: flex;
      justify-content: center;
      input {
        border: 0;
        border-bottom: 1px solid #000000;
        font-size: 1.3rem;
      }
      a {
        font-size: 2.5rem;
      }
    }
  }
  h3 {
    line-height: 60px;
    font-size: 1.2rem;
    font-weight: bold;
  }
}
</style>